import SectionHub from '@/components/docs/SectionHub';

export default function Docs03FundamentalsEarningsHub() {
  return <SectionHub sectionPath="03-fundamentals/earnings" />;
}
